export default __webpack_public_path__ + "73dc3008aab9b8e23f9c49ef7ee3efd7.svg";